<header class="header">
  <a href="{{origin}}">
    <nv-logo class="header-logo" type="portal"></nv-logo>
  </a>
</header>

<main class="not-found-content">
  <h1>404 – Page not found</h1>
  <nv-button (clickButton)="goToLogin()">Go home</nv-button>
  <not-found-svg></not-found-svg>
</main>

<generic-footer></generic-footer>